import PropTypes from 'prop-types'
import React from 'react'
// import NotifyApiErrorDetail from './notify-api-error-detail'
import './notify-api-error.css'


const propTypes = {
  id       : PropTypes.string,
  apiError : PropTypes.oneOfType(
    [
      PropTypes.object,
      PropTypes.string
    ]
  )
}

/**
 * Notify the API error messages and detail
 * @param {object} apiError - Error Object from the Backend
 */
const NotifyApiError = ({ apiError }) => {

  const errorDetails = apiError?.messages || {}

  const messagesFor = (errorKey) => {
    const value = errorDetails[errorKey]
    if (Array.isArray(value)) return value
    if (value === undefined || value === null) return []
    return [ value ]
  }

  const hasErrorDetails = () => Object.keys(errorDetails).length > 0

  return (
    <>
      <span className='mr-1 font-weight-bold'>
        { apiError?.message || 'Oops... Something went wrong.' }
      </span>
      {
        hasErrorDetails() && (
          <div className='mt-5'>
            {
              Object.keys(errorDetails).map((errorKey) => (
                <ul key={ `error-${errorKey}` }>
                  {
                    messagesFor(errorKey).map((message, index) => (
                      <li key={ `error-${errorKey}-${index}` }>{ message }</li>
                    ))
                  }
                </ul>
              ))
            }
          </div>
        )
      }
    </>
  )
}

NotifyApiError.propTypes = propTypes

export default NotifyApiError
